import { render, staticRenderFns } from "./home_store.vue?vue&type=template&id=a6a635ec&scoped=true"
import script from "./home_store.vue?vue&type=script&lang=js"
export * from "./home_store.vue?vue&type=script&lang=js"
import style0 from "./home_store.vue?vue&type=style&index=0&id=a6a635ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a635ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a635ec')) {
      api.createRecord('a6a635ec', component.options)
    } else {
      api.reload('a6a635ec', component.options)
    }
    module.hot.accept("./home_store.vue?vue&type=template&id=a6a635ec&scoped=true", function () {
      api.rerender('a6a635ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_store.vue"
export default component.exports